import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function save({token_auth, rfc, email, cellphone, interbank_clabe, bank_name, concepts, document_list}) {
  const resource = `/fas/undue_discount_request/create`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    email: email,
    cellphone: cellphone,
    interbank_clabe: interbank_clabe,
    bank_name: bank_name,
    concepts: concepts,
    document_list: document_list,
  }

  return post(API_URL, params, config)
}

function reject(token_auth, requestId) {
  const resource = `/fas/undue_discount_request/reject`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: requestId
  }

  return post(API_URL, params, config)
}

function cancel(token_auth, requestId) {
  const resource = `/fas/undue_discount_request/cancel`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: requestId
  }

  return post(API_URL, params, config)
}

function getByRfc (token_auth, rfc) {    
  const resource = `/fas/undue_discount_request/get_by_rfc`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc
  }
  
  return get(API_URL, { params, config })
}

function getAll (token_auth, process_name) {    
  const resource = `/fas/undue_discount_request/get_all`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    process_name: process_name
  }
  
  return get(API_URL, { params, config })
}

export default {
  getByRfc: getByRfc,
  save: save,
  cancel: cancel,
  getAll: getAll,
  reject: reject
} 